<template>
  <div class="home">
    <div class="wrap">   
      <div class="sign">
        <div class="radius_1 radius" v-show="tActive"></div>
        <div class="radius_2 radius" v-show="tActive"></div>
        <div class="radius_3 radius" v-show="!tActive"></div>
        <div class="radius_4 radius" v-show="!tActive"></div>
        <div class="radius_5 radius" v-show="tActive"></div>
        <div class="radius_6 radius" v-show="!tActive"></div>
        <div class="title">
          <div :class="['identity', {iActive: index == n }]" v-for="(item, index) in items" @click="toggle(index)"><span>{{item.identity}}</span></div>
        </div>
        <div class = "sign-body">
          <div id="signIn" class="s-form" v-show="n == 0" >
            <form id="signInForm" @submit.prevent="signIn">
              <label for="">高校邦账号</label>
              <div class="field">
                <input name="username" type="text" v-model="user.userName" placeholder="请输入账号">
                <div class="warning" v-show="warnPhone" ref="warnPhone">请输入手机号码!</div>
              </div>             
              <label for="">密码</label>
              <div class="field">
                <input name="password" type="password" v-model="user.password" placeholder="请输入密码">
                <div class="warning" v-show="warnPassword" ref="warnPassword">请输入密码!</div>
              </div>
              <router-link to='/resetPassword' class="forgetpwd">
                忘记密码？
              </router-link>                     
              <div class="signUp">
                <input class="btn-primary btn" type="submit" value="登录">
              </div>
              <router-link class="rtSignUp" to='/signUp'>
               注册
              </router-link>                              
              <button class="btn wanxiang" @click="goThirdLogin">万象登录</button>
            </form>
          </div>
          
          <div class="s-form joinRoom" v-show="n == 1" >
            <form id="joinRoomForm" @submit.prevent="joinRoom">
              <label for="">教室ID（询问老师6位教室ID）</label>
              <div class="field">   
                <input name="roomid" type="text" v-model="roomId" ref="roomId" placeholder="请输入教室ID">
                <div class="warning">{{errorTip.room}}</div>
              </div>
              <label style="color: #DADBDC;" for="">姓名</label>
              <div class="field">   
                <input name="name" type="text" v-model="name" ref="name" placeholder="请输入真实姓名">
                <div class="warning">{{errorTip.name}}</div>
              </div>
              <br>
              <button class="btn btn-primary" type="submit">加入教室</button>                     
            </form>
              <!-- <label for="">教室ID</label>
              <div class="field">   
                <input name="name" type="text" v-model="roomId" ref="roomId">
                <div class="warning" ref="roomTip"></div>
              </div>
              <label style="color: #DADBDC;" for="">询问老师6位教室ID</label>
              <div class="field">   
                <input name="name" type="text" v-model="name" ref="name" placeholder="请输入真实姓名">
                <div class="warning" ref="roomTip"></div>
              </div>
              <br>
              <button class="btn btn-primary" @click="joinRoom">加入教室</button>   -->  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/ 
import { ajaxAPI } from '@/utils/ajaxUtil'
import { HYBIRD_URL } from '@/config/url_config'
import { loadUserData } from '@/api'
export default {
  components: {
  },
  data () {
    return {
      user: {
        userName: '',
        password: ''
      },
      newUser: {
        phone: '',
        password: '',
        vertify: ''
      },
      n: 0,
      warnPhone: false,
      warnPassword: false,
      items: [
        {identity: '老师'},
        {identity: '学生'}
      ],
      roomId: '',
      name: '',
      tActive: true,
      errorTip: {
        room: '',
        name: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    toggle (index) {
      this.n = index
      if (index === 0) {
        this.tActive = true
      } else {
        this.tActive = false       
      }
    },
    signIn () {
      let loginData = this.user
      console.log('提交数据', loginData)      
      let url = `${HYBIRD_URL}/user/loginWithoutTenant`
      // console.log('loginData:', loginData)
      this.warnPhone = false
      this.warnPassword = false

      if (!loginData.userName) {
        this.warnPhone = true
        this.$refs.warnPhone.innerHTML = '用户名不能为空'
        return false
      }
      if (!loginData.password) {
        this.warnPassword = true
        this.$refs.warnPassword.innerHTML = '请输入密码'
        return false
      }
      loadUserData(loginData).then(data => {
        console.log('登录数据', data)
        if (data.data.status === '1') {
          this.warnPassword = true
          this.$refs.warnPassword.innerHTML = data.data.message
        } else {
          this.warnPassword = false
          this.$refs.warnPassword.innerHTML = data.data.message
        }
        window.localStorage.setItem('accessToken', data.data.data.accessToken)
        window.localStorage.setItem('userInfo', JSON.stringify(data.data.data))
        this.$router.push('ClassRoom')
      })
    },
    goThirdLogin() {
      let url = `${HYBIRD_URL}/wanxiang/getAuth`
      ajaxAPI('GET', url).then(data => {
        console.log(data)
        var data = data.data
        let url = data.url
        let state = data.state
        let response_type = data.response_type
        let redirect_uri = data.redirect_uri
        let client_id = data.client_id

        let href = `${url}?state=${state}&response_type=${response_type}&redirect_uri=${redirect_uri}&client_id=${client_id}`
        // for(let key in data){
        //   url += data[key]&
        // }
        console.log(href)
        window.location.href = href
      }).catch(error => {
        console.log(error)
      })
    },
    joinRoom () {
      console.log('0000')
      let _this = this

      this.errorInfo()

      let url = `${HYBIRD_URL}/programming/userProgramming/language/roomId/${this.roomId}/api`
      ajaxAPI('GET', url).then(data => {
        console.log(data)
        if (!data.data.data) {
          _this.$refs.roomTip.innerHTML = '请输入正确的教室ID'
        }
        if (data.data.data.languageId === '35') {
          this.$router.push({ name: 'WebStudent', params: {roomId: this.roomId}, query: {name: this.name} })
        } else{
          this.$router.push({name: 'Play', params: {roomId: this.roomId, languageId: data.data.data.languageId}, query: {name: this.name}  })
        }
      }).catch(error => {
        console.log('error ---------- ')
        console.log(error)
      })
    },
    errorInfo() {
      if (!this.roomId) {
        this.errorTip.room = '请输入教室ID'
        return false
      } else {
        this.errorTip.room = ''
      }
      if (!this.name) {
        this.errorTip.name = '用户名不能为空'
        return false
      } else {
        this.errorTip.name = ''
      }
    }
  }
}
</script>

<style>
  input{
    outline: 0
  }
  .home{
    text-align: center;
    color:#666666;
  } 
  .forgetpwd{
    color: #818E99;
    display:block;
    text-align:right;
  }
  .iActive{
    color: #1FB6FF !important;
    background: #fff !important
  }
  .wanxiang:hover{
    color: #22B8FF;  
  }
  .radius{
    position: absolute;
    width: 4px;
    height: 4px;
  }
  .radius_1{
    left: 50%;
    background: -webkit-radial-gradient(0% 100%, circle, rgb(255, 255, 255) 49%, rgb(107, 213, 249) 100%);
    transform: translateX(-4px);
  } 
  .home .radius_2{
    right: 0;
    top: 60px;
    background: -webkit-radial-gradient(0% 100%, circle, #fffffe 51%, rgb(107, 213, 249) 100%);
  }
  .radius_3{
    left: 50%;
    background: -webkit-radial-gradient(100% 100% , circle, rgb(255, 255, 255) 49%, rgb(107, 213, 249) 100%);
  }
  .radius_4{
    top: 60px;
    background: -webkit-radial-gradient(100% 100% , circle, rgb(255, 255, 255) 49%, rgb(107, 213, 249) 100%);
  }
  .radius_5{
    left: 50%;
    top: 56px;
    background: -webkit-radial-gradient(100% 0 , circle, rgb(107, 213, 249) 50%, rgb(255, 255, 255) 100%);
  }
  .radius_6{
    left: 50%;
    top: 56px;
    background: -webkit-radial-gradient(0 0 , circle, rgb(107, 213, 249) 50%, rgb(255, 255, 255) 100%);
    transform: translateX(-4px);
  }   
</style>



// WEBPACK FOOTER //
// home.vue?5de28b30